import React from 'react'
import './emptyStateFriends.css'

const EmptyStateFriends = () => {
    const PF = process.env.REACT_APP_PUBLIC_FOLDER

    return (
        <div className='emptyState'>
            <div className='emptyStateFriendsWrapper'>
                <img src={PF + 'person/nofriends.png'} alt="" className='illustration-friends'/>
                <p className='no-friends-yet'>No Friends yet</p>
            </div>
        </div>
    )
}

export default EmptyStateFriends